module.exports = __webpack_public_path__ + "img/Psyhic-J-0.22425108.svg";